import { render, staticRenderFns } from "./switchLoading.vue?vue&type=template&id=70b6343b&scoped=true"
import script from "./switchLoading.vue?vue&type=script&lang=js"
export * from "./switchLoading.vue?vue&type=script&lang=js"
import style0 from "./switchLoading.vue?vue&type=style&index=0&id=70b6343b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6343b",
  null
  
)

export default component.exports